import React, { useState, useEffect, useRef } from "react";
import { Input, Checkbox, Button, Spin } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getGroupProducts } from "../../API  Functions/productGroupFunctions";
import LoadingSpinner from "../../components/Loading";

const NewGroup_Modal = ({
  open,
  onClose,
  onSave,
  editData,
  onUpdateGroup,
  groupLoading,
}) => {
  const { t, i18n } = useTranslation();
  const [searchByShortCode, setSearchByShortCode] = useState(false);

  const [englishName, setEnglishName] = useState("");
  const [arabicName, setArabicName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const userData = useSelector((state) => state?.login?.user?.result);

  const dropdownRef = useRef(null);
  const toggleBtnRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        toggleBtnRef.current &&
        !toggleBtnRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  // Fetch products
  const getProducts = async (val = "") => {
    setLoading(true);
    try {
      if (searchByShortCode) {
        let payload = {
          lang: i18n.language == "ar" ? "ar_001" : "en_US",
          short_code: val,
          type: "all", //required // all or low or high or out
          company_id: userData?.company_id,
        };
        const response = await axiosInstance.post(
          URLS.GET_STOCK_BY_CODE,
          payload,
        );
        if (response?.data?.result[0]?.response) {
          setProducts(response?.data?.result[0].response);
        }
      } else {
        const payload = {
          user_id: userData?.user_id,
          company_id: userData?.company_id,
          category_id: false,
          product_name: val,
          limit: 10,
          offset: 0,
          lang: i18n.language === "ar" ? "ar_001" : "en_US",
        };
        const res = await axiosInstance.post(URLS.GET_ALL_PRODUCTS, payload);
        //   console.log("PRIODYCYD", res);

        const result = res?.data?.result[0]?.response || [];
        setProducts(result);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const getProductsofGroup = async () => {
    try {
      const payload = {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        company_id: company_id,
        user_id: user_id,
        group_id: editData.id,
      };
      const res = await getGroupProducts(payload);

      // console.log("resresresres---->", res);

      if (res?.result[0]?.status_code === 200) {
        setSelectedProducts(res?.result[0]?.product_list || []);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (editData) {
      getProductsofGroup();
      setEnglishName(editData?.name);
      setArabicName(editData?.name_ar);
    }
  }, [editData]);

  //   useEffect(() => {
  //     if (open) getProducts();
  //   }, [open]);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery.length > 1) getProducts(searchQuery);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const toggleProduct = (id) => {
    setSelectedProducts((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };

  const handleClose = () => {
    setEnglishName("");
    setArabicName("");
    setSearchQuery("");
    setSelectedProducts([]);
    setShowDropdown(false);
    onClose?.();
  };

  const handleSave = () => {
    if (englishName.trim() === "" || arabicName.trim() === "") {
      toast.error(t("Please enter both English and Arabic group names."));
      return;
    }

    // if (selectedProducts.length === 0) {
    //   toast.error(t("Please select at least one product."));
    //   return;
    // }
    if (editData) {
      onUpdateGroup(englishName, arabicName, selectedProducts, editData?.id);
    } else {
      onSave?.({
        englishName,
        arabicName,
        selectedProducts,
      });
    }

    // handleClose();
  };

  if (!open) return null; // hide modal when closed

  // console.log("PROROR", products);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(0,0,0,0.4)",
      }}
    >
      {groupLoading && <LoadingSpinner />}
      {/* Modal container */}
      <div className="relative w-[600px] max-h-[60vh] bg-white rounded-[20px] p-6 shadow-2xl animate-fadeIn">
        {/* Close Button (optional) */}
        <button
          onClick={handleClose}
          // className="absolute top-4 right-4 text-gray-400 hover:text-black text-2xl font-semibold"
          className={`absolute top-4 ${i18n.language === "ar" ? "left-4" : "right-4"} text-gray-400 hover:text-black text-2xl font-semibold`}
        >
          ×
        </button>

        {/* Title */}
        <h2 className="text-lg font-bold mb-4">
          {editData ? t("Edit Product Group") : t("Create New Group")}
        </h2>

        {/* Group Name Section */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold mb-2 text-gray-600">
            {t("Group Name")}
          </h3>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-xs mb-2 font-medium text-gray-600">
                {t("English")}
              </label>
              <Input
                size="small"
                placeholder={t("Enter group name")}
                value={englishName}
                // onChange={(e) => {
                //     const val = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                //     setEnglishName(val.trimStart()); // trims leading space
                // }}
                onChange={(e) => {
                  const val = e.target.value.replace(
                    /[^\u0600-\u06FFa-zA-Z0-9\s]/g,
                    "",
                  ); // Allow Arabic letters, Latin letters, numbers, and spaces
                  setEnglishName(val.trimStart()); // Trims leading spaces
                }}
                maxLength={20}
                onBlur={() => setEnglishName((prev) => prev.trim())} // trims both ends on blur
                className="rounded-md h-8 text-xs"
              />
            </div>
            <div>
              <label className="block text-xs mb-2 font-medium text-gray-600">
                {t("Arabic")}
              </label>
              <Input
                size="small"
                placeholder="أدخل اسم المجموعة"
                value={arabicName}
                onChange={(e) => {
                  const val = e.target.value.replace(
                    /[^\u0600-\u06FFa-zA-Z0-9\s]/g,
                    "",
                  ); // Allow Arabic letters, Latin letters, numbers, and spaces
                  setArabicName(val.trimStart()); // Trims leading spaces
                }}
                maxLength={20}
                onBlur={() => setArabicName((prev) => prev.trim())} // trims both ends on blur
                dir="rtl"
                className="rounded-md h-8 text-xs"
              />
            </div>
          </div>
        </div>

        {/* Product Dropdown Section */}
        <div className="mb-8 relative">
          <label className="block text-sm mb-2 font-semibold text-gray-600">
            {t("Product List")}
          </label>

          <button
            ref={toggleBtnRef}
            onClick={() => setShowDropdown(!showDropdown)}
            className="w-full flex items-center justify-between border border-gray-300 rounded-md h-8 px-4 text-xs focus:outline-none"
          >
            <span>
              {selectedProducts.length > 0
                ? `${selectedProducts.length} ${t("selected")}`
                : t("Select products")}
            </span>
            <DownOutlined
              className={`transition-transform ${
                showDropdown ? "rotate-180" : ""
              }`}
            />
          </button>

          {showDropdown && (
            <div
              ref={dropdownRef}
              className="absolute z-50 left-0 right-0 bg-white border border-gray-200 rounded-md shadow-lg w-full mt-2 overflow-y-auto p-2 custom-scrollbar"
              style={{ maxHeight: "200px" }}
            >
              <div className="flex gap-x-2">
                <Input
                  prefix={<SearchOutlined />}
                  placeholder={t("Search products...")}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="mb-2 text-xs h-8 rounded-md focus:outline-none"
                  suffix={
                    searchQuery && (
                      <span
                        onClick={() => setSearchQuery("")}
                        className="cursor-pointer text-gray-400 hover:text-gray-600 text-xs font-semibold"
                      >
                        ×
                      </span>
                    )
                  }
                />
                <button
                  type="button"
                  onClick={() => {
                    if (searchByShortCode) {
                      setSearchQuery("");
                    }
                    setSearchByShortCode(!searchByShortCode);
                  }}
                  className={`h-8 px-2 rounded-md border text-xs whitespace-nowrap
    ${
      searchByShortCode
        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
        : "bg-white border-gray-300 text-gray-700"
    }`}
                >
                  {t("Search Code")}
                </button>
              </div>
              {loading ? (
                <div className="flex justify-center text-xs py-2">
                  <Spin />
                </div>
              ) : products.length > 0 && searchQuery.length > 1 ? (
                <>
                  {products.map((p) => {
                    const id = p.quant_id ?? p.prod_id ?? p.id; // try common id fields
                    const isSelected = selectedProducts.includes(id);

                    return (
                      <div
                        key={id}
                        // allow row click to toggle as well
                        onClick={() => {
                          // console.log("ROW CLICK", { id, product: p });
                          toggleProduct(id);
                        }}
                        className={`flex items-center py-1 px-2 rounded-lg cursor-pointer hover:bg-green-50 ${
                          isSelected ? "bg-green-50" : ""
                        }`}
                      >
                        <Checkbox
                          // checkbox controlled by selectedProducts
                          checked={isSelected}
                          // stop event bubbling to row, but handle toggle here
                          onChange={(e) => {
                            e.stopPropagation(); // prevent row's onClick from also running
                            // console.log("CHECKBOX CHANGE", { id, checked: e.target.checked });
                            toggleProduct(id);
                          }}
                          // prevent the label click from bubbling when user clicks the text
                          onClick={(e) => e.stopPropagation()}
                        >
                          <span className="ms-2 text-gray-800 text-xs">
                            {p.product_name2 && p.product_name2 != ""
                              ? p.product_name2
                              : p.product_name}
                          </span>
                        </Checkbox>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  {searchQuery.length > 1 && (
                    <p className="text-center text-gray-400 py-4">
                      {t("No products found")}
                    </p>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-white text-primaryBlue border-primaryBlue hover:bg-red-600`}
          >
            {t("Cancel")}
          </button>
          <button
            onClick={handleSave}
            className={`px-8 py-2 font-semibold text-xs border rounded-lg bg-primaryBlue text-white border-primaryBlue hover:bg-red-600`}
          >
            {t("Save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewGroup_Modal;
